<template>
    <div class="SortContainer">
        <span class="title">{{ $t("sort.label") }}</span>
        <select v-model="localValue">
            <option value="">{{ $t("sort.default") }}</option>
            <option value="PRICE_ASC">{{ $t("sort.price_asc") }}</option>
            <option value="PRICE_DESC">{{ $t("sort.price_desc") }}</option>
        </select>
        <!-- <button @click.prevent="handleClick">{{ $lang }}</button> -->
    </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    props: ['value'],

    computed: {
      localValue: {
        get () {
          return this.value || '';
        },
        set (val) {
          this.$emit('input', val);
        }
      }
    },

    methods: {
      handleClick () {
        let locale = this.$lang === 'tr' ? 've' : 'tr';

        Vue.config.lang = locale;
      }
    }
  };
</script>

<style scoped>
  .SortContainer {
    padding: 3px 10px;
  }

  .SortContainer .title {
    font-weight: 300;
    font-family: 'Roboto Condensed';
  }

  select {
    font-weight: 300;
    font-family: 'Roboto';
    /* line-height: 1.5em; */
    height: 2.5em;
    border: 1px solid #737373;
  }


  @media screen and (max-width : 575px) {
    .SortContainer select {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// sort.vue?ef95aa8c